import { render, staticRenderFns } from "./categories.vue?vue&type=template&id=9f286ffa&scoped=true&"
import script from "./categories.vue?vue&type=script&lang=js&"
export * from "./categories.vue?vue&type=script&lang=js&"
import style0 from "./categories.vue?vue&type=style&index=0&id=9f286ffa&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f286ffa",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IntSlides: require('/var/www/pb-store/components/IntSlides.vue').default,CategoriesGrid: require('/var/www/pb-store/components/CategoriesGrid.vue').default})
